import api from './api.js'


// 获取平台产品选型分类树
export function productTypetree(params){
    return api.get(`/resource-product/api/v1/product/category/typetree`,params);
}

// 获取平台参数
export function getProductParams(params){
    return api.get('/resource-product/api/v1/product/standard/list',params);
}

// 首页产品
export function getProductList(params){
    return api.post('/resource-product/api/v1/product/portalQuery',params);
}

// 获取全部产品品牌列表
export function getAllProductBrandList(params){
    return api.get('/resource-product/api/v1/product/brand/list',params);
}

export function queryAllProductBrandList(params){
    return api.post('/resource-product/api/v1/product/brand/listNew',params);
}

// 获取产品信息
export function getProductInfo(uuid){
    return api.get(`/resource-product/api/v1/product/detail?uuid=${uuid}`,);
}
// 规格名称搜索
export function getProductInfoSpecifiactionName(params){
    return api.post(`/resource-product/api/v1/product/specification/list`,params);
}
// 获取规格信息
export function geSpecification(uuid){
    return api.get(`/resource-product/api/v1/product/specificationDetail?uuid=${uuid}`,);
}

export function addProductConsult(data){
    return api.post('/resource-product/api/v1/product/order/buyer/consult', data);
}

// 首页产品
export function getProductSpecList(params){
    return api.post('/resource-product/api/v1/product/specification/query',params);
}
//添加购物车
export function addProductCart(params){
    return api.post("/resource-product/api/v1/productCart/save",params)
}
//查询购物车列表
export function getProductCart(){
    return api.get("/resource-product/api/v1/productCart/findAll");
}

export function deleteProductCart(uuid){
    return api.post(`/resource-product/api/v1/productCart/deleteById?uuid=${uuid}`);
}
export function submitProductOrder(data){
    return api.post(`/resource-product/api/v1/productCart/provider/consult`,data);
}
//计算购物车商品数量
export function countProductCartNum(){
    return api.get("/resource-product/api/v1/productCart/count")
}

//查询厂商名称
export function getCompanyName(params){
    return api.get("/resource-product/api/v1/product/company/name",params)
}

//查询产品名称
export function getProductName(params){
    return api.get("/resource-product/api/v1/product/product/name",params)
}
//查询产品规格名称
export function getProductSpecName(params){
    return api.get("/resource-product/api/v1/product/specification/productSpec/name",params)
}

//查询当前用户入驻的企业
export function getDealer(){
    return api.get("/resource-product/api/v1/seller/dealer/findByUserId")
}



// WEBPACK FOOTER //
// ./src/utils/product.js